/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { SchedulingScheduleTemplateTaskBusinessService } from '../../../resources/scheduling-schedule-template-task-business.service';
import { SchedulingScheduleTemplateTaskDetailsTodoDialogComponent } from './scheduling-schedule-template-task-todo-dialog.component';

export const scheduleTemplateTaskTodoDialog = createDialogRoute({
  component: SchedulingScheduleTemplateTaskDetailsTodoDialogComponent,
  init: {
    service: SchedulingScheduleTemplateTaskBusinessService,
    selector: 'initTodoDialogView',
  },
});
